export default __webpack_public_path__ + "static/hero-thumb-3-c7afbc4792879aa87f5c64ea3f3fdb04.png";